import React from 'react';
import {useTranslation} from 'react-i18next';
import {Select, MenuItem, FormControl} from "@mui/material";

const LanguageSwitcher = () => {
    const {i18n} = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang).then(() => {
            console.log("Language changed to:", lang);
        });
    };

    return (
        <FormControl size="small" variant="standard" sx={{ borderBottom: "none" }}>
            <Select
                sx={{
                    color: "white",
                    borderBottom: "none",
                    "&:before": {
                        borderBottom: "none !important",
                    },
                    "&:after": {
                        borderBottom: "none !important",
                    },
                    "& .MuiSvgIcon-root": {
                        color: "white",
                    },
                    backgroundColor: "transparent",
                }}
                value={i18n.language}
                onChange={(e) => changeLanguage(e.target.value)}
                renderValue={(selected) => selected.toUpperCase()}
                MenuProps={{
                    disableScrollLock: true,
                }}
             variant="standard">
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="hy">Հայերեն</MenuItem>
                <MenuItem value="ru">Русский</MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageSwitcher;
